import { createElement, type ReactElement } from 'react';
import { View } from 'react-native';

/** Stroke icon paths copied from the design (lucide-style, 24×24). */
const PATHS = {
  bell: ['M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9', 'M10.3 21a1.94 1.94 0 0 0 3.4 0'],
  bag: ['M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z', 'M3 6h18', 'M16 10a4 4 0 0 1-8 0'],
  bike: ['M15 6h3l3 8', 'M5.5 17.5 9 9h6l3.5 8.5', 'circle:5.5,17.5,3.5', 'circle:18.5,17.5,3.5'],
  store: ['M3 9 4.5 4h15L21 9', 'M4 9v11h16V9', 'M9 20v-6h6v6'],
  pin: ['M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z', 'circle:12,10,3'],
  chevronDown: ['m6 9 6 6 6-6'],
  chevronLeft: ['m15 18-6-6 6-6'],
  chevronRight: ['m9 18 6-6-6-6'],
  plus: ['M12 5v14M5 12h14'],
  minus: ['M5 12h14'],
  check: ['M20 6 9 17l-5-5'],
  close: ['M18 6 6 18M6 6l12 12'],
  home: ['m3 10 9-7 9 7v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z', 'M9 22V12h6v10'],
  cup: ['M5 8h14l-1.5 13a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1z', 'M4 5h16v3H4zM14 5l2-3'],
  receipt: ['M4 2v20l3-2 3 2 2-2 2 2 3-2 3 2V2l-3 2-3-2-2 2-2-2-3 2z', 'M8 9h8M8 13h6'],
  gift: ['M3 8h18v4H3z', 'M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7', 'M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5'],
  user: ['circle:12,8,4', 'M4 21a8 8 0 0 1 16 0'],
  qr: ['M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3z', 'M14 14h3v3h-3zM20 14v.01M14 20h.01M17 20h4v-3'],
  heart: ['M19 14c1.5-1.5 3-3.2 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.8 0-3 .5-4.5 2-1.5-1.5-2.7-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4 3 5.5l7 7Z'],
  lock: ['M3 11h18v11H3z', 'M7 11V7a5 5 0 0 1 10 0v4'],
  message: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'],
  phone: ['M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z'],
  file: ['M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z', 'M14 2v6h6M8 13h8M8 17h5'],
  camera: ['M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3z', 'circle:12,13,3'],
  upload: ['M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4', 'm17 8-5-5-5 5', 'M12 3v12'],
  navigation: ['m3 11 19-9-9 19-2-8z'],
  history: ['M3 12a9 9 0 1 0 3-6.7L3 8', 'M3 3v5h5', 'M12 7v5l4 2'],
  wallet: ['M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1', 'M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4'],
  arrowRight: ['M5 12h14', 'm12 5 7 7-7 7'],
  logout: ['M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', 'm16 17 5-5-5-5', 'M21 12H9'],
  search: ['circle:11,11,8', 'm21 21-4.3-4.3'],
  star: ['m12 2 3 7h7l-5.5 4.5L18.5 21 12 16.5 5.5 21l2-7.5L2 9h7z'],
  checkCircle: ['circle:12,12,10', 'm8 12 3 3 5-6'],
  trash: ['M3 6h18', 'M8 6V4h8v2', 'M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6'],
  pencil: ['M17 3a2.8 2.8 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z'],
  ticket: ['M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 0 0-4z', 'M13 5v2M13 17v2M13 11v2'],
  clock: ['circle:12,12,10', 'M12 6v6l4 2'],
  alert: ['circle:12,12,10', 'M12 8v4M12 16h.01'],
} as const;

export type IconName = keyof typeof PATHS;

export type IconProps = {
  name: IconName;
  size?: number;
  color?: string;
  strokeWidth?: number;
  /** Fill the shape instead of stroking it (used for the gold star). */
  filled?: boolean;
};

/**
 * Renders inline SVG through react-dom, which react-native-web runs on.
 * A native build would swap this file for a react-native-svg version.
 */
export const Icon = ({ name, size = 22, color = 'currentColor', strokeWidth = 2, filled = false }: IconProps): ReactElement => {
  const children = PATHS[name].map((d, index) => {
    if (d.startsWith('circle:')) {
      const [cx, cy, r] = d.slice(7).split(',');
      return createElement('circle', { key: index, cx, cy, r });
    }
    return createElement('path', { key: index, d });
  });
  const svg = createElement(
    'svg',
    {
      width: size,
      height: size,
      viewBox: '0 0 24 24',
      fill: filled ? color : 'none',
      stroke: filled ? 'none' : color,
      strokeWidth,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      'aria-hidden': true,
      style: { display: 'block' },
    },
    children,
  );
  return <View style={{ width: size, height: size }}>{svg}</View>;
};
